(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-process"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const animations = new WeakMap();
    const animationOptions = {
      duration: 360,
      easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
      fill: 'forwards'
    };

    const getContent = (details) => details.querySelector('.accordion-item__content');

    const cleanContentStyles = (content) => {
      content.style.height = '';
      content.style.opacity = '';
      content.style.overflow = '';
    };

    const setOpenContentStyles = (content) => {
      content.style.height = `${content.scrollHeight}px`;
      content.style.opacity = '';
      content.style.overflow = 'visible';
    };

    const cancelCurrentAnimation = (details) => {
      const currentAnimation = animations.get(details);

      if (currentAnimation) {
        currentAnimation.cancel();
        animations.delete(details);
      }
    };

    const closeDetails = (details) => {
      const content = getContent(details);

      if (!details.open || !content) {
        return;
      }

      cancelCurrentAnimation(details);

      if (prefersReducedMotion.matches || typeof content.animate !== 'function') {
        details.open = false;
        return;
      }

      const startHeight = content.getBoundingClientRect().height || content.scrollHeight;
      content.style.height = `${startHeight}px`;
      content.style.overflow = 'hidden';

      const animation = content.animate([
        { height: `${startHeight}px`, opacity: 1 },
        { height: '0px', opacity: 0 }
      ], animationOptions);

      animations.set(details, animation);

      animation.onfinish = () => {
        content.style.height = '0px';
        details.open = false;
        cleanContentStyles(content);
        animations.delete(details);
      };

      animation.oncancel = () => {
        cleanContentStyles(content);
        animations.delete(details);
      };
    };

    const openDetails = (details) => {
      const content = getContent(details);

      if (details.open || !content) {
        return;
      }

      cancelCurrentAnimation(details);
      details.open = true;

      if (prefersReducedMotion.matches || typeof content.animate !== 'function') {
        return;
      }

      const endHeight = content.scrollHeight;
      content.style.height = '0px';
      content.style.opacity = '0';
      content.style.overflow = 'hidden';

      const animation = content.animate([
        { height: '0px', opacity: 0 },
        { height: `${endHeight}px`, opacity: 1 }
      ], animationOptions);

      animations.set(details, animation);

      animation.onfinish = () => {
        setOpenContentStyles(content);
        animations.delete(details);
      };

      animation.oncancel = () => {
        cleanContentStyles(content);
        animations.delete(details);
      };
    };

    for (const accordion of document.querySelectorAll('.product-process__accordion')) {
      if (accordion.dataset.smoothAccordionInitialized === 'true') {
        continue;
      }

      accordion.dataset.smoothAccordionInitialized = 'true';

      accordion.addEventListener('click', (event) => {
        if (!(event.target instanceof Element)) {
          return;
        }

        const summary = event.target.closest('.accordion-item__summary');

        if (!summary || !accordion.contains(summary)) {
          return;
        }

        const activeItem = summary.closest('details.accordion-item');

        if (!activeItem) {
          return;
        }

        event.preventDefault();

        if (activeItem.open) {
          closeDetails(activeItem);
          return;
        }

        for (const item of accordion.querySelectorAll('details.accordion-item[open]')) {
          if (item !== activeItem) {
            closeDetails(item);
          }
        }

        openDetails(activeItem);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
